import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BaseCard from '../BaseCard';
import getFavoriteHook from '@hooks/getFavoriteHook';

// hidden on mobile
const CardImage = styled.img`
    box-shadow: 0 10px 15px 0 rgb(0 0 0 / 30%);
    object-fit: cover;
    height: 132px;
    width: 104px;
`;

const PublicationCard = props => {
    const {
        id,
        title,
        url,
        image,
        formats = [],
        isFavorite: initialIsFavorite,
        onClick = () => {},
        isLoggedIn = false,
    } = props;

    const useFavorite = getFavoriteHook({ type: 'publication', initialIsFavorite });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite } = useFavorite();

    const onFavorite = () => {
        if (isFavorite) {
            removeFavorite(id);
        } else {
            saveFavorite(id);
        }
    };

    const imageBlock = (
        <>
            <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link">
                <div className="d-flex justify-content-center">
                    {image && <CardImage className="mt-4 d-block mx-auto" src={image} alt={title} />}
                    {!image && (
                        <CardImage
                            src="/assets/images/generic-icon-publications.svg"
                            alt=""
                            className="mt-4 d-block mx-auto"
                        />
                    )}
                </div>
            </a>
        </>
    );

    return (
        <BaseCard
            id={id}
            type="publication"
            title={title}
            url={url}
            onClick={onClick}
            isFavorite={isFavorite}
            onFavorite={onFavorite}
            isLoadingFavorite={isLoadingFavorite}
            imageBlock={imageBlock}
            isLoggedIn={isLoggedIn}
            contentBlock={
                <>
                    <a
                        onClick={() => onClick(url)}
                        onKeyDown={() => onClick(url)}
                        className="card-link"
                        role="button"
                        tabIndex="0"
                    >
                        <h3 className="card-title mt-4 mb-0 display6 d6-truncate3 bold truncate-lines">{title}</h3>
                        {formats.length > 0 && <p className="display8 secondary mt-3 mb-0">{formats.join(',')}</p>}
                    </a>
                </>
            }
        />
    );
};

PublicationCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    image: PropTypes.string,
    formats: PropTypes.array,
    isFavorite: PropTypes.bool,
    onClick: PropTypes.func,
    isLoggedIn: PropTypes.bool,
};

export default PublicationCard;
